import request from 'utils/request';

export default async function saveZip(body: any): Promise<any> {
  try {
    await request(`/lineDriveService/mfgRepDetails/update  `, {
      method: 'PUT',
      body: [body]
    });
  } catch (error) {
    let errorMessage = 'Failed to do something exceptional';
    if (error instanceof Error) {
      errorMessage = error.message;
    }
    console.log(errorMessage);
  }
}
